import { useMemo } from 'react';
import { ICenter } from '@nkr/models/index';
import { FileDocumentType } from '@nkr/enums/index';
import { FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { ReportWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';

interface IProps {
    data: ICenter[],
    onDownloadFile: (docType: FileDocumentType, id: number) => void
}

const Grid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    const columns = [
        {
            colId: 'rank',
            headerName: 'Rank',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    R#
                </SortableHeaderComponent>,
            width: 50,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            colId: 'alias',
            field: 'alias',
            headerName: 'Center Alias',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center Alias</SortableHeaderComponent>,
            width: 150
        },
        {
            colId: 'donorCenterAgreement',
            field: 'donorCenterAgreement',
            headerName: 'Donor Center Agreement',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Donor Center Agreement</SortableHeaderComponent>,
            width: 200,
            cellRendererFramework: (params: ICellRendererParams) => {
                return (
                    <Button bsSize='xsmall' onClick={() => props.onDownloadFile(FileDocumentType.DonorCenterAgreement, params.data.id)}>
                        Click to View
                    </Button>
                );
            }
        },
        {
            colId: 'recipientCenterAgreement',
            field: 'recipientCenterAgreement',
            headerName: 'Recipient Center Agreement',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Recipient Center Agreement</SortableHeaderComponent>,
            width: 155,
            cellRendererFramework: (params: ICellRendererParams) => {
                return (
                    <Button bsSize='xsmall' onClick={() => props.onDownloadFile(FileDocumentType.RecipientCenterAgreement, params.data.id)}>
                        Click to View
                    </Button>
                );
            }
        },
        {
            colId: 'cmsGoodStanding',
            field: 'cmsGoodStanding',
            headerName: 'CMS Center in Good Standing',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>CMS Center in Good Standing</SortableHeaderComponent>,
            width: 155,
            cellRendererFramework: (params: ICellRendererParams) => {
                return (
                    <Button bsSize='xsmall' bsStyle='primary' onClick={() => props.onDownloadFile(FileDocumentType.CmsGoodStanding, params.data.id)}>
                        Click to View
                    </Button>
                );
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <ReportWrapper className='ag-theme-bootstrap'>
            <AgGridReact
                defaultColDef={{
                    headerClass: 'list-header',
                    cellClass: 'list-cell',
                    sortable: true,
                    resizable: false
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={30}
                rowHeight={30}
                suppressRowClickSelection={false}
                suppressCellSelection={true}
                noRowsOverlayComponentFramework={() => <div>No center information available...</div>}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onSortChanged={onSortChanged}
            />
        </ReportWrapper>
    );
}

export default Grid;